/**
 * formatStoredDate.ts
 *
 * Small helper to display server-stored timestamps without forcing a local timezone
 * conversion when the backend returned SQL-style or plain ISO strings. Returns
 * the original string when it looks like a DB timestamp; otherwise falls back
 * to a localized representation when parsing succeeds.
 */
export function formatStoredDate(dt?: string | null): string {
  if (!dt) return '—';
  try {
    const s = String(dt).trim();
    const sqlLike = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?$/;
    if (sqlLike.test(s)) return s;
    if (/^\d{4}-\d{2}-\d{2}T.*Z$/.test(s)) return s.replace('T', ' ').replace(/Z$/, '');
    if (/^\d{4}-\d{2}-\d{2}T/.test(s)) return s.replace('T', ' ');
    const d = new Date(s);
    return isNaN(d.getTime()) ? s : d.toLocaleString();
  } catch {
    return String(dt);
  }
}
